export default {"src":"/_next/static/media/Quantarium.2c829574.svg","height":60,"width":60};